import React from 'react';

import LandingService from 'components/_landing';
import { NextPage } from 'next';
import { AxiosResponse } from 'axios';
import { GetMain } from 'api/site';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const index: NextPage<{ main: any }> = ({ main }) => {
  return <LandingService data={main} />;
};

index.getInitialProps = async () => {
  const main: AxiosResponse = await GetMain();

  return { main: main.data };
};

export default index;
